import React, { Component } from "react";
import { connect } from "react-redux";

import { fetchSesEmailsStatuses, registerFromEmail } from "thunks";
import Switch from "common/Switch";
import _ from "i18n";
import {
  getEmailDomain,
  registerDomainSES,
  checkDomainSES,
  SES_FAILED_STATUS,
  SES_SUCCESS_STATUS,
  SES_PENDING_STATUS,
  SES_UNREGISTERED_STATUS,
} from "../../../services/email";
import {
  SVG_MINUS,
  IS_EMAIL_VALID,
  SVG_VALID_ICON,
  SVG_INVALID,
} from "../../../services/svgIcones";
import {
  getFillClassName,
  isValidEmail,
  onError,
} from "../../../services/utils";

@connect(
  (state) => ({
    registeredEmails: state.params.sesEmails?.items || [],
  }),
  (dispatch) => ({
    fetchSesEmailsStatuses: () => dispatch(fetchSesEmailsStatuses()),
    registerFromEmail: (email) => dispatch(registerFromEmail(email)),
  }),
)
export default class EmailItem extends Component {
  constructor(props) {
    super(props);
    this.handleNameChange = (e) =>
      this.setState({ name: e.target.value, showButtons: true });
    this.state = {
      ...this.getInitialState(props),
      registrationStatus: SES_FAILED_STATUS,
      fromNameHasError: false,
      domainStatus: null,
      domainData: null,
      showDnsDetails: false,
    };
  }

  componentDidMount() {
    this.updateSesEmailStatus();
  }

  validateFromName = (value) => {
    this.setState({ fromNameHasError: value && value.trim().length < 5 });
  };

  getInitialState = () => {
    const { email, name, main, showAction, showButtons } = this.props;
    return {
      email: email ? email : "",
      name: name ? name : "",
      main: main ? main : 0,
      showAction: showAction ? true : false,
      showButtons: showButtons ? true : false,
    };
  };

  updateSesEmailStatus = () => {
    const { registeredEmails } = this.props;
    const { email } = this.state;
    let registrationStatus = SES_FAILED_STATUS;
    if (isValidEmail(email)) {
      registrationStatus = SES_UNREGISTERED_STATUS;
      for (let key in registeredEmails) {
        if (key === this.state.email) {
          registrationStatus =
            registeredEmails[key].VerificationStatus.toUpperCase();
          break;
        }
      }
      if (registrationStatus == SES_FAILED_STATUS) {
        registrationStatus = SES_UNREGISTERED_STATUS;
      }
    }

    this.setState({ registrationStatus });
  };

  handleEmailChange = (e) => {
    const value = e.target.value;

    this.setState({
      email: value,
      showButtons: true,
    });

    this.verifyDomain(value);
  };

  handleMainChange = () => {
    this.props.handleMainChange();
    this.setState({ showButtons: !this.props.isMain });
  };

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      const newState = this.getInitialState();
      this.props.setMainEmailIndex();
      this.setState({ ...newState, showAction: false });
    }
  };

  verifyDomain = async (email) => {
    if (!isValidEmail(email)) {
      this.setState({ domainStatus: null, domainData: null });
      return;
    }

    const domain = getEmailDomain(email);
    if (!domain) return;

    try {
      const result = await checkDomainSES(domain);

      if (result.verified === true) {
        this.setState({
          domainStatus: SES_SUCCESS_STATUS,
          domainData: null,
        });
        return;
      }

      if (result.status === "pending") {
        this.setState({
          domainStatus: SES_PENDING_STATUS,
          domainData: result,
        });
        return;
      }

      this.setState({
        domainStatus: SES_UNREGISTERED_STATUS,
        domainData: result,
      });
    } catch (error) {
      console.error("Domain verification failed", error);
    }
  };
  handleVerifyDomain = async () => {
    const { email } = this.state;
    const domain = getEmailDomain(email);

    if (!domain) return;

    try {
      const result = await registerDomainSES(domain);

      this.setState({
        domainStatus: SES_PENDING_STATUS,
        domainData: result,
        showDnsDetails: true,
      });
    } catch (error) {
      console.error(error);
    }
  };

  handleSave = () => {
    const { email, name, registrationStatus, fromNameHasError, domainStatus } =
      this.state;
    const { main } = this.props;
    if (
      !email ||
      SES_SUCCESS_STATUS !== registrationStatus ||
      fromNameHasError
    ) {
      return;
    }
    this.props.onSave({ email, name, main });
    this.setState({ showAction: false, showButtons: false });
  };

  registerEmail = () => {
    const { email } = this.state;
    this.props.registerFromEmail(email).then(
      (res) => this.onSuccess(res),
      () => onError(),
    );
  };

  onSuccess(res) {
    const {
      value: { data },
    } = res;
    if (!(res.value instanceof Error) && data.result === "OK") {
      this.setState({ registrationStatus: SES_PENDING_STATUS });
    } else {
      onError();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { email, name, main, registeredEmails } = this.props;
    const changed =
      this.state.email !== email ||
      this.state.name !== name ||
      (this.state.main !== main && prevState.main === 0) ||
      (this.state.main === main && prevState.main !== 0);

    if (
      prevState.email !== this.state.email ||
      registeredEmails !== prevProps.registeredEmails
    ) {
      this.updateSesEmailStatus();
    }
    if (changed !== this.state.showAction) {
      this.setState({ showAction: changed });
    }
    if (this.state.name !== prevState.name) {
      this.validateFromName(this.state.name);
    }

    if (prevProps.email !== email || prevProps.name != name) {
      this.setState(this.getInitialState());
    }
  }

  render() {
    const {
      email,
      name,
      showAction,
      registrationStatus,
      fromNameHasError,
      showButtons,
      domainStatus,
      domainData,
    } = this.state;
    const { deleteState, onDelete, fetchSesEmailsStatuses, main } = this.props;
    const records = domainData?.dns_records_to_add || [];

    const dkimRecords = records.filter((r) => r.purpose.includes("DKIM"));
    const otherRecords = records.filter((r) => !r.purpose.includes("DKIM"));
    return (
      <div
        className="medium-4 small-6"
        onClick={deleteState ? onDelete : null}
        style={{ flex: "0 0 33.33333%", maxWidth: "33.33333%" }}
      >
        <div
          className={`${deleteState ? " mail-list-item delete" : "mail-list-item"}`}
        >
          {domainStatus === SES_PENDING_STATUS && isValidEmail(email) && (
            <div className="warning">
              <p>{_("domain_pending_dns")}</p>

              <button
                className="info"
                onClick={() =>
                  this.setState({ showDnsDetails: !this.state.showDnsDetails })
                }
              >
                {this.state.showDnsDetails ? _("read_less") : _("Read_more")}
              </button>
            </div>
          )}

          {domainStatus === SES_UNREGISTERED_STATUS && isValidEmail(email) && (
            <div className="warning">
              <p>{_("domain_not_registered")}</p>

              <button
                className="verify-domain-btn"
                onClick={this.handleVerifyDomain}
              >
                {_("click_to_verify_domain")}
              </button>
            </div>
          )}
          {this.state.showDnsDetails &&
            this.state.domainData &&
            domainStatus === SES_PENDING_STATUS && (
              <div className="warning">
                {this.state.domainData.dns_records_to_add ? (
                  <>
                    <h5>{_("dns_records_to_add")}</h5>

                    {otherRecords.map((rec, i) => {
                      const isOptional = rec.purpose
                        .toLowerCase()
                        .includes("verification");

                      return (
                        <div key={i} className="dns-record">
                          <div>
                            <strong>Type:</strong> {rec.type}
                          </div>
                          <div>
                            <strong>Name:</strong> {rec.name}
                          </div>

                          <div>
                            <strong>Value:</strong>
                            <code className="dns-value">{rec.value}</code>
                          </div>

                          <div
                            className={`dns-badge ${isOptional ? "optional" : "required"}`}
                          >
                           {isOptional ? _("optional") : _("required")}
                          </div>

                          <div className="dns-purpose">{rec.purpose}</div>
                        </div>
                      );
                    })}

                    {/*DKIM GROUP */}
                    {dkimRecords.length > 0 && (
                      <div className="dns-record">
                        <div>
                          <strong>Type:</strong> CNAME (DKIM)
                        </div>

                        <div>
                          {dkimRecords.map((rec, i) => (
                            <div key={i} className="dns-list-item">
                              <strong>Name {i + 1}:</strong> {rec.name}
                            </div>
                          ))}
                        </div>

                        <div>
                          {dkimRecords.map((rec, i) => (
                            <div key={i}>
                              <strong>Value {i + 1}:</strong>
                              <code className="dns-value">{rec.value}</code>
                            </div>
                          ))}
                        </div>

                        <div className="dns-badge required">{_("required")}</div>

                        <div className="dns-purpose">
                         {_("DKIM is required to sign your emails and improve deliverability.")}
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <h5>{_("dns_status")}</h5>

                    <ul className="dns-list">
                      <li className="dns-item">
                        <span>TXT verification</span>
                        {this.state.domainData.dns_status
                          ?.verification_txt_exists
                          ? SVG_VALID_ICON
                          : SVG_INVALID}
                      </li>

                      <li className="dns-item">
                        <span>DKIM records</span>
                        {this.state.domainData.dns_status?.dkim_records_exist
                          ? SVG_VALID_ICON
                          : SVG_INVALID}
                      </li>

                      <li className="dns-item">
                        <span>SPF configured</span>
                        {this.state.domainData.dns_status?.spf_includes_ses
                          ? SVG_VALID_ICON
                          : SVG_INVALID}
                      </li>

                      <li className="dns-item">
                        <span>DMARC</span>
                        {this.state.domainData.dns_status?.dmarc_exists
                          ? SVG_VALID_ICON
                          : SVG_INVALID}
                      </li>
                    </ul>

                    <h5>{_("tokens_to_use")}</h5>

                    <div className="dns-record">
                      <div className="dns-header">
                        <strong>Verification TXT</strong>
                      </div>
                      <code className="dns-value">
                        {this.state.domainData.verification_token}
                      </code>
                    </div>

                    <div className="dns-record">
                      <div className="dns-header">
                        <strong>DKIM</strong>
                      </div>

                      {this.state.domainData.dkim_tokens?.map((t, i) => (
                        <code key={i} className="dns-value">
                          {t}
                        </code>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
          {[SES_PENDING_STATUS, SES_UNREGISTERED_STATUS].indexOf(
            registrationStatus,
          ) > -1 && (
            <div className="warning">
              {SES_PENDING_STATUS === registrationStatus
                ? _("reply_aws_email")
                : _("register_from_email")}
            </div>
          )}
          <div className="mail-list-item__main">
            <div>
              <label className={`label_delete`} hidden={!deleteState}>
                {SVG_MINUS}
                {_("delete")}
              </label>
            </div>
            <div className="flex-container">
              <span className="text-capitalize">{_("main email")}</span>
              <Switch
                name="main"
                isChecked={main === 1}
                onChange={this.handleMainChange}
              />
            </div>
          </div>
          <span className="param-label">{_("name")}</span>
          <div className="mail-list-item__items name">
            <input
              type="text"
              className={getFillClassName(name)}
              onChange={this.handleNameChange}
              value={name}
            />
            <span
              className={
                fromNameHasError && showAction && name.length > 0
                  ? "form-error is-visible"
                  : "form-error"
              }
            >
              {" "}
              {_("invalidFromName")}
            </span>
          </div>
          <span className="param-label">{_("sender")}</span>
          <div className="mail-list-item__items email-field">
            <input
              type="text"
              className={getFillClassName(email)}
              onChange={(e) => {
                this.handleEmailChange(e);
              }}
              value={email}
            />
            {IS_EMAIL_VALID(SES_SUCCESS_STATUS === registrationStatus)}
          </div>
          <span
            className={`form-error ${showAction && email.length > 0 && SES_FAILED_STATUS === registrationStatus && "is-visible"}`}
          >
            {_("invalidEmail")}
          </span>
        </div>
        {showAction && showButtons && (
          <div className="ttp-small-buttons">
            <button className="cancel" onClick={this.handleCancel}>
              {_("cancel")}
            </button>
            {[SES_SUCCESS_STATUS, SES_FAILED_STATUS].indexOf(
              registrationStatus,
            ) > -1 && (
              <button className="success" onClick={this.handleSave}>
                {_("save")}
              </button>
            )}
            {SES_UNREGISTERED_STATUS === registrationStatus && (
              <button className="info" onClick={this.registerEmail}>
                {_("submit")}
              </button>
            )}
            {SES_PENDING_STATUS === registrationStatus && (
              <button className="info" onClick={fetchSesEmailsStatuses}>
                {_("refresh")}
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
}
